import styled from 'styled-components';
import { layout } from 'src/components/base';
import type { Color } from './types';
import { Variant } from './types';

type CounterProps = {
  variant: Variant;
  color: Color;
};

export const Counter = styled.span<CounterProps>`
  padding: 0 ${layout.measurements.spacing050};
  border-radius: ${layout.measurements.spacing100};
  font-size: ${layout.measurements.fontSizeMedium};
  line-height: 1.5;

  background: ${p =>
    p.variant === Variant.DARK
      ? p.theme.buttons[p.color].bg
      : p.theme.buttons[p.color].text};
  color: ${p =>
    p.variant === Variant.DARK
      ? p.theme.buttons[p.color].text
      : p.theme.buttons[p.color].bg};
`;
